import Account from '_core_ext/components/forms/Account';

export default class Subscription extends Account {
    init() {
        super.init();
        this.event('click', '.js-gender-type-selection input', () => this.toggleGenderValidationError(false));
        this.expandReadMoreNotSubscribed();
        this.expandReadMoreSubscribed();
        this.expandReadMoreNewsletterLanding();
        this.additionalvalidators = [
            this.genderSelectionValidation.bind(this)
        ];
        
    }


    expandReadMoreNotSubscribed() {
        var showReadMoreNotSubscribedBlock = $('.show-read-more-notsubscribed .form-row_label.js-input-label');
        if (showReadMoreNotSubscribedBlock) {
            var readMoreseo = Resources.VIEWMORE;
            var readLessseo = Resources.VIEWLESS;
            let $readMoreNotSubscribedBlock = $('.read-more-notsubscribed');
            if(!$readMoreNotSubscribedBlock.length){
            $('<a href="javascript:void(0);" class="read-more-notsubscribed"><span class="read-more-text-notsubscribed">' + readMoreseo + '</span></a>').insertAfter($(showReadMoreNotSubscribedBlock));
            var showReadMoreNotSubscribed = $(".show-read-more-notsubscribed");
            var readMoreNotSubscribed = $(".read-more-notsubscribed");
            var readMoreTextNotSubscribed = readMoreNotSubscribed.find('.read-more-text-notsubscribed');
            readMoreNotSubscribed.click(function () {
                    if(!readMoreNotSubscribed.hasClass('read-less')){
                        readMoreTextNotSubscribed.text(readLessseo);
                        $(readMoreNotSubscribed).addClass('read-less');
                        $(showReadMoreNotSubscribed).addClass('read-less');
                    }else{
                        readMoreTextNotSubscribed.text(readMoreseo);
                        $(readMoreNotSubscribed).removeClass('read-less');
                        $(showReadMoreNotSubscribed).removeClass('read-less');
                    }
                });
            }    
        }
    }

    expandReadMoreSubscribed() {
        var showReadMoreSubscribedBlock = $('.show-read-more-subscribed .form-row_label.js-input-label');
        if (showReadMoreSubscribedBlock) {
            var readMoreseo = Resources.VIEWMORE;
            var readLessseo = Resources.VIEWLESS;
            let $readMoreSubscribedBlock = $('.read-more-subscribed');
            if(!$readMoreSubscribedBlock.length){
            $('<a href="javascript:void(0);" class="read-more-subscribed"><span class="read-more-text-subscribed">' + readMoreseo + '</span></a>').insertAfter($(showReadMoreSubscribedBlock));
            var showReadMoreSubscribed = $(".show-read-more-subscribed");
            var readMoreSubscribed = $(".read-more-subscribed");
            var readMoreTextSubscribed = readMoreSubscribed.find('.read-more-text-subscribed');
            readMoreSubscribed.click(function () {
                    if(!readMoreSubscribed.hasClass('read-less')){
                        readMoreTextSubscribed.text(readLessseo);
                        $(readMoreSubscribed).addClass('read-less');
                        $(showReadMoreSubscribed).addClass('read-less');
                    }else{
                        readMoreTextSubscribed.text(readMoreseo);
                        $(readMoreSubscribed).removeClass('read-less');
                        $(showReadMoreSubscribed).removeClass('read-less');
                    }
                });
            }    
        }
    }

    expandReadMoreNewsletterLanding() {
        var showReadMoreNewsletterLandingBlock = $('.show-read-more-newsletterlanding .form-row_label.js-input-label');
        if (showReadMoreNewsletterLandingBlock) {
            var readMoreseo = Resources.VIEWMORE;
            var readLessseo = Resources.VIEWLESS;
            let $readMoreNewsletterLandingBlock = $('.read-more-newsletterlanding');
            if(!$readMoreNewsletterLandingBlock.length){
            $('<a href="javascript:void(0);" class="read-more-newsletterlanding"><span class="read-more-text-newsletterlanding">' + readMoreseo + '</span></a>').insertAfter($(showReadMoreNewsletterLandingBlock));
            var showReadMoreNewsletterLanding = $(".show-read-more-newsletterlanding");
            var readMoreNewsletterLanding = $(".read-more-newsletterlanding");
            var readMoreTextNewsletterLanding = readMoreNewsletterLanding.find('.read-more-text-newsletterlanding');
            readMoreNewsletterLanding.click(function () {
                    if(!readMoreNewsletterLanding.hasClass('read-less')){
                        readMoreTextNewsletterLanding.text(readLessseo);
                        $(readMoreNewsletterLanding).addClass('read-less');
                        $(showReadMoreNewsletterLanding).addClass('read-less');
                    }else{
                        readMoreTextNewsletterLanding.text(readMoreseo);
                        $(readMoreNewsletterLanding).removeClass('read-less');
                        $(showReadMoreNewsletterLanding).removeClass('read-less');
                    }
                });
            }    
        }
    }

    genderSelectionValidation() {
        var $genderSelection = this.$el.find('.js-gender-type-selection');
        var $newsletterPolicy = this.$el.find('.js-newsletter-policy');
        if (!$genderSelection.length || !$newsletterPolicy.prop('checked')) {
            return true;
        }

        var isValid = !!$genderSelection.find('input')
            .filter((i, checkbox) => checkbox.checked)
            .length;

        if (!isValid) {
            this.toggleGenderValidationError(true);
        }

        return isValid;
    }

    toggleGenderValidationError(show) {
        if (show) {
            this.$el.find('.js-gender-type-error-msg').fadeIn();
            if ($('.recaptcha-verify').length) {
                var googleRecaptcha = require('_core_ext/googleRecaptcha');
                googleRecaptcha.buildRecaptchaV2();
            }
        } else {
            this.$el.find('.js-gender-type-error-msg').fadeOut();
        }
    }
}